import React, { useState } from 'react'
import Layout from '../../../components/layout/Layout'
import { ChevronLeftIcon, RefreshIcon } from '@heroicons/react/solid'
// useSearchParams was only needed for the scheme switcher
// import { Link, useParams, useNavigate, useSearchParams } from 'react-router-dom'
import { Link, useParams, useNavigate } from 'react-router-dom'
import usePut from '../../../hooks/usePut'
// import useGet from '../../../hooks/read/useGet'
import spinner from '../../../assets/images/spinner.gif'
import toast, { Toaster } from 'react-hot-toast'
// import SchemeSwitcher from '../components/SchemeSwitcher'

const CreateEmployeeSalary = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    // const [searchParams, setSearchParams] = useSearchParams()

    // New Scheme is the only active scheme.
    // const [selectedScheme, setSelectedScheme] = useState(
    //     searchParams.get('scheme') || 'old'
    // )
    const [selectedScheme] = useState('new')

    // Fetch salary structures list (only needed by the scheme switcher)
    // const { list: structureListReq } = useGet({
    //     url: 'salary-structure/list',
    //     initialData: {
    //         page_number: 0,
    //         limit: 50,
    //         search_query: '',
    //     },
    // })

    // const structureList = structureListReq?.data?.data || []

    // const handleSchemeChange = (slug) => {
    //     setSelectedScheme(slug)
    //     const nextParams = new URLSearchParams(searchParams)
    //     nextParams.set('scheme', slug)
    //     setSearchParams(nextParams, { replace: true })
    // }

    const initialSalaryState = {
        basic_monthly: '',
        basic_yearly: '',
        hra_monthly: '',
        hra_yearly: '',
        da_monthly: '',
        da_yearly: '',
        conveyance_monthly: '',
        conveyance_yearly: '',
        other_allowance_monthly: '',
        other_allowance_yearly: '',
        stat_bonus_monthly: '',
        stat_bonus_yearly: '',
        employer_epf_monthly: '',
        employer_epf_yearly: '',
        washing_allowance_monthly: '',
        washing_allowance_yearly: '',
        supplementary_allowance_monthly: '',
        supplementary_allowance_yearly: '',
        travel_allowance_monthly: '',
        travel_allowance_yearly: '',
        variable_fixed_monthly: '',
        variable_fixed_yearly: '',
        monthly_ctc: '',
        annual_ctc: '',
        is_bonus_eligible: false,
        from_date: new Date().toISOString().split('T')[0],
        previous_year: false,
    }

    const [salaryForm, setSalaryForm] = useState(initialSalaryState)

    const handleChangeDateDetail = (e) => {
        let value = e.target.value
        let name = e.target.name
        setSalaryForm((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const getNumericValue = (val) => (val === '' || isNaN(+val) ? 0 : +val)

    // Frontend dynamic calculation for Total incl. and Total Excl.
    const totalInclusiveMonthly =
        getNumericValue(salaryForm.basic_monthly) +
        getNumericValue(salaryForm.da_monthly)
    const totalInclusiveYearly = totalInclusiveMonthly * 12

    const totalExclusiveMonthly =
        getNumericValue(salaryForm.hra_monthly) +
        getNumericValue(salaryForm.stat_bonus_monthly) +
        getNumericValue(salaryForm.employer_epf_monthly)
    const totalExclusiveYearly = totalExclusiveMonthly * 12

    const calculateSalary = () => {
        let calculatedSalary = {
            ...salaryForm,
        }

        if (selectedScheme === 'new') {
            const basicM = getNumericValue(salaryForm.basic_monthly)
            const daM = getNumericValue(salaryForm.da_monthly)
            const hraM = getNumericValue(salaryForm.hra_monthly)
            const statBonusM = getNumericValue(salaryForm.stat_bonus_monthly)
            const employerEpfM = getNumericValue(salaryForm.employer_epf_monthly)
            // Legacy new scheme fields kept for backward compatibility
            const conveyanceM = getNumericValue(salaryForm.conveyance_monthly)
            const otherM = getNumericValue(salaryForm.other_allowance_monthly)
            const variableFixedM = getNumericValue(salaryForm.variable_fixed_monthly)

            const totalInclusiveM = basicM + daM
            const totalExclusiveM = hraM + statBonusM + employerEpfM
            const monthlyCTC =
                totalInclusiveM + totalExclusiveM + conveyanceM + otherM + variableFixedM

            calculatedSalary = {
                ...calculatedSalary,
                basic_yearly: basicM * 12,
                da_yearly: daM * 12,
                hra_yearly: hraM * 12,
                stat_bonus_yearly: statBonusM * 12,
                employer_epf_yearly: employerEpfM * 12,
                conveyance_yearly: conveyanceM * 12,
                other_allowance_yearly: otherM * 12,
                variable_fixed_yearly: variableFixedM * 12,
                monthly_ctc: monthlyCTC,
                annual_ctc: monthlyCTC * 12,
            }
        } else {
            const basicM = getNumericValue(salaryForm.basic_monthly)
            const daM = getNumericValue(salaryForm.da_monthly)
            const hraM = getNumericValue(salaryForm.hra_monthly)
            const taM = getNumericValue(salaryForm.travel_allowance_monthly)
            const waM = getNumericValue(salaryForm.washing_allowance_monthly)
            const saM = getNumericValue(salaryForm.supplementary_allowance_monthly)
            const variableFixedM = getNumericValue(salaryForm.variable_fixed_monthly)

            const monthlyCTC = basicM + daM + hraM + taM + waM + saM + variableFixedM

            calculatedSalary = {
                ...calculatedSalary,
                basic_yearly: basicM * 12,
                da_yearly: daM * 12,
                hra_yearly: hraM * 12,
                travel_allowance_yearly: taM * 12,
                washing_allowance_yearly: waM * 12,
                supplementary_allowance_yearly: saM * 12,
                variable_fixed_yearly: variableFixedM * 12,
                monthly_ctc: monthlyCTC,
                annual_ctc: monthlyCTC * 12,
            }
        }

        setSalaryForm({ ...calculatedSalary })
    }

    const handleChangeCents = (e) => {
        let value = e.target.value === '' ? '' : +e.target.value
        let name = e.target.name
        setSalaryForm((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const calculateData = () => {
        calculateSalary()
    }

    const createSalary = usePut({
        url: 'createEmployeeSalary',
        onSuccess: () => {
            toast.success('Salary Created Successfully')
            navigate(`/employee-salary-details/${id}?scheme=${selectedScheme}`)
        },
        onError: () => {
            toast.error('There was an error while creating salary')
        },
    })

    const handleSaveSalary = () => {
        let annualCTC = 0
        if (selectedScheme === 'new') {
            annualCTC =
                (getNumericValue(salaryForm.basic_monthly) +
                    getNumericValue(salaryForm.da_monthly) +
                    getNumericValue(salaryForm.hra_monthly) +
                    getNumericValue(salaryForm.stat_bonus_monthly) +
                    getNumericValue(salaryForm.employer_epf_monthly) +
                    getNumericValue(salaryForm.conveyance_monthly) +
                    getNumericValue(salaryForm.other_allowance_monthly) +
                    getNumericValue(salaryForm.variable_fixed_monthly)) *
                12
        } else {
            annualCTC =
                (getNumericValue(salaryForm.basic_monthly) +
                    getNumericValue(salaryForm.hra_monthly) +
                    getNumericValue(salaryForm.da_monthly) +
                    getNumericValue(salaryForm.supplementary_allowance_monthly) +
                    getNumericValue(salaryForm.travel_allowance_monthly) +
                    getNumericValue(salaryForm.washing_allowance_monthly) +
                    getNumericValue(salaryForm.variable_fixed_monthly)) *
                12
        }

        if (!salaryForm.from_date || !annualCTC) {
            return alert(
                'Please Enter All The Details: "ANNUAL CTC" and "EFFECT FROM DATE" '
            )
        }

        let data = {
            ...salaryForm,
            employee_id: id,
            scheme_type: selectedScheme,
            annual_ctc: annualCTC,
            is_bonus_eligible: Boolean(salaryForm.is_bonus_eligible),
            from_date: Math.floor(new Date(salaryForm.from_date).getTime() / 1000),
            to_date: 0,
            previous_year: false,
        }

        createSalary.handleAuth.mutate(data)
    }

    return (
        <Layout>
            <Toaster />
            {createSalary.handleAuth.isLoading && (
                <div className="fixed top-0 left-0 z-50 w-full h-full bg-[#ffffffa1] flex items-center justify-center">
                    <img src={spinner} className="w-14 h-14 mx-auto" alt="loading" />
                </div>
            )}
            <div className="px-4 py-4 flex justify-between sticky bg-white top-16 shadow-lg z-40">
                <div className="flex items-center space-x-4">
                    <button
                        onClick={() => navigate(-1, { replace: true })}
                        className="flex items-center hover:underline"
                    >
                        <ChevronLeftIcon className="w-6 h-6" />
                        <span className="font-semibold">Back</span>
                    </button>
                    <h2 className="text-2xl font-semibold">Add New Salary Details</h2>
                </div>
                <div className="flex items-center space-x-4">
                    <button
                        onClick={handleSaveSalary}
                        disabled={createSalary.handleAuth.isLoading}
                        className={`px-5 py-2 bg-yellow-300 rounded font-semibold inline-flex items-center ${
                            createSalary.handleAuth.isLoading
                                ? 'opacity-70 cursor-not-allowed'
                                : ''
                        }`}
                    >
                        {createSalary.handleAuth.isLoading && (
                            <RefreshIcon className="w-5 h-5 animate-spin mr-2" />
                        )}
                        <span>Save Details</span>
                    </button>
                    <Link
                        to={`/employee-salary-details/${id}?scheme=${selectedScheme}`}
                        className="px-5 py-2 bg-blue-100 rounded font-semibold"
                    >
                        View Salary
                    </Link>
                </div>
            </div>

            <div className="px-4 my-5">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-6">
                        <div className="w-full sm:w-auto">
                            <label htmlFor="from_date" className="label">
                                Effect From:<span className="mandatory">*</span>
                            </label>
                            <div>
                                <div className="flex items-center space-x-2">
                                    <input
                                        type="date"
                                        name="from_date"
                                        className="input"
                                        value={salaryForm.from_date}
                                        placeholder="Enter Effect From Date"
                                        onChange={handleChangeDateDetail}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* {selectedScheme === 'new' && (
                            <div className="flex items-center space-x-2 sm:mt-6">
                                <input
                                    type="checkbox"
                                    id="is_bonus_eligible"
                                    name="is_bonus_eligible"
                                    checked={Boolean(salaryForm.is_bonus_eligible)}
                                    onChange={(e) =>
                                        setSalaryForm((prev) => ({
                                            ...prev,
                                            is_bonus_eligible: e.target.checked,
                                        }))
                                    }
                                    className="w-4 h-4 text-color1 rounded focus:ring-0 cursor-pointer"
                                />
                                <label
                                    htmlFor="is_bonus_eligible"
                                    className="font-semibold text-gray-700 cursor-pointer select-none text-sm"
                                >
                                    Bonus Eligible
                                </label>
                            </div>
                        )} */}
                    </div>

                    {/* Scheme Switcher - hidden, New Scheme is the only active scheme */}
                    {/* <SchemeSwitcher
                        structureList={structureList}
                        selectedScheme={selectedScheme}
                        handleSchemeChange={handleSchemeChange}
                    /> */}
                </div>

                <div className="px-10 border border-gray-200 mt-6">
                    <div className="grid grid-cols-8 gap-x-8 border-b border-gray-200 py-4">
                        <div className="col-span-2">
                            <label className="label">SALARY COMPONENTS:</label>
                        </div>
                        <div className="col-span-2">
                            <label className="label">MONTHLY AMOUNT:</label>
                        </div>
                        <div className="col-span-2 text-center">
                            <label className="label">ANNUAL AMOUNT:</label>
                        </div>
                    </div>
                    <div className="space-y-8 pb-8">
                        <div className="mt-5">
                            <h2 className="font-semibold text-xl">Earnings</h2>
                        </div>

                        {/* Basic */}
                        <div className="grid grid-cols-8 mt-5 gap-x-8">
                            <div className="col-span-2">
                                <label htmlFor="basic_monthly" className="label">
                                    Basic:
                                </label>
                            </div>
                            <div className="col-span-2">
                                <div className="flex items-center space-x-2">
                                    <input
                                        onWheel={(e) => e.target.blur()}
                                        type="number"
                                        name="basic_monthly"
                                        value={salaryForm.basic_monthly}
                                        onBlur={calculateData}
                                        onChange={handleChangeCents}
                                        className="input"
                                        placeholder="0"
                                    />
                                </div>
                            </div>
                            <div className="col-span-2 text-center">
                                <label
                                    htmlFor="basic_yearly"
                                    className="label bg-gray-100 input h-[2.6rem]"
                                >
                                    {salaryForm?.basic_yearly}
                                </label>
                            </div>
                        </div>

                        {/* DA */}
                        <div className="grid grid-cols-8 mt-5 gap-x-8">
                            <div className="col-span-2">
                                <label htmlFor="da_monthly" className="label">
                                    DA:
                                </label>
                            </div>
                            <div className="col-span-2">
                                <div className="flex items-center space-x-2">
                                    <input
                                        onWheel={(e) => e.target.blur()}
                                        type="number"
                                        name="da_monthly"
                                        value={salaryForm.da_monthly}
                                        onBlur={calculateData}
                                        onChange={handleChangeCents}
                                        className="input"
                                        placeholder="0"
                                    />
                                </div>
                            </div>
                            <div className="col-span-2 text-center">
                                <label
                                    htmlFor="da_yearly"
                                    className="label bg-gray-100 input h-[2.6rem]"
                                >
                                    {salaryForm?.da_yearly}
                                </label>
                            </div>
                        </div>

                        {selectedScheme === 'new' ? (
                            // New Scheme Fields (matches Payout Wages table)
                            <>
                                {/* Total incl. */}
                                <div className="grid grid-cols-8 mt-5 gap-x-8 bg-gray-50 py-2 rounded -mx-2 px-2">
                                    <div className="col-span-2 flex items-center">
                                        <label className="label font-bold text-gray-800">
                                            Total incl.:
                                        </label>
                                    </div>
                                    <div className="col-span-2">
                                        <div className="label bg-gray-200 font-bold input h-[2.6rem] flex items-center">
                                            &#8377; {totalInclusiveMonthly}
                                        </div>
                                    </div>
                                    <div className="col-span-2 text-center">
                                        <div className="label bg-gray-200 font-bold input h-[2.6rem] flex items-center justify-center">
                                            &#8377; {totalInclusiveYearly}
                                        </div>
                                    </div>
                                </div>

                                {/* HRA */}
                                <div className="grid grid-cols-8 mt-5 gap-x-8">
                                    <div className="col-span-2">
                                        <label htmlFor="hra_monthly" className="label">
                                            HRA:
                                        </label>
                                    </div>
                                    <div className="col-span-2">
                                        <div className="flex items-center space-x-2">
                                            <input
                                                onWheel={(e) => e.target.blur()}
                                                type="number"
                                                name="hra_monthly"
                                                value={salaryForm.hra_monthly}
                                                onBlur={calculateData}
                                                onChange={handleChangeCents}
                                                className="input"
                                                placeholder="0"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-span-2 text-center">
                                        <label
                                            htmlFor="hra_yearly"
                                            className="label bg-gray-100 input h-[2.6rem]"
                                        >
                                            {salaryForm?.hra_yearly}
                                        </label>
                                    </div>
                                </div>

                                {/* Stat Bonus */}
                                <div className="grid grid-cols-8 mt-5 gap-x-8">
                                    <div className="col-span-2">
                                        <label htmlFor="stat_bonus_monthly" className="label">
                                            Stat Bonus:
                                        </label>
                                    </div>
                                    <div className="col-span-2">
                                        <input
                                            onWheel={(e) => e.target.blur()}
                                            type="number"
                                            name="stat_bonus_monthly"
                                            value={salaryForm.stat_bonus_monthly}
                                            onBlur={calculateData}
                                            onChange={handleChangeCents}
                                            className="input"
                                            placeholder="0"
                                        />
                                    </div>
                                    <div className="col-span-2 text-center">
                                        <label
                                            htmlFor="stat_bonus_yearly"
                                            className="label bg-gray-100 input h-[2.6rem]"
                                        >
                                            {salaryForm?.stat_bonus_yearly}
                                        </label>
                                    </div>
                                </div>

                                {/* Employer PF */}
                                <div className="grid grid-cols-8 mt-5 gap-x-8">
                                    <div className="col-span-2">
                                        <label htmlFor="employer_epf_monthly" className="label">
                                            Employer PF:
                                        </label>
                                    </div>
                                    <div className="col-span-2">
                                        <input
                                            onWheel={(e) => e.target.blur()}
                                            type="number"
                                            name="employer_epf_monthly"
                                            value={salaryForm.employer_epf_monthly}
                                            onBlur={calculateData}
                                            onChange={handleChangeCents}
                                            className="input"
                                            placeholder="0"
                                        />
                                    </div>
                                    <div className="col-span-2 text-center">
                                        <label
                                            htmlFor="employer_epf_yearly"
                                            className="label bg-gray-100 input h-[2.6rem]"
                                        >
                                            {salaryForm?.employer_epf_yearly}
                                        </label>
                                    </div>
                                </div>

                                {/* Total Excl. */}
                                <div className="grid grid-cols-8 mt-5 gap-x-8 bg-gray-50 py-2 rounded -mx-2 px-2">
                                    <div className="col-span-2 flex items-center">
                                        <label className="label font-bold text-gray-800">
                                            Total Excl.:
                                        </label>
                                    </div>
                                    <div className="col-span-2">
                                        <div className="label bg-gray-200 font-bold input h-[2.6rem] flex items-center">
                                            &#8377; {totalExclusiveMonthly}
                                        </div>
                                    </div>
                                    <div className="col-span-2 text-center">
                                        <div className="label bg-gray-200 font-bold input h-[2.6rem] flex items-center justify-center">
                                            &#8377; {totalExclusiveYearly}
                                        </div>
                                    </div>
                                </div>

                                {/* Legacy new scheme fields kept commented out to avoid code deletion */}
                                {/*
                                <div className="grid grid-cols-8 mt-5 gap-x-8">
                                    <div className="col-span-2">
                                        <label htmlFor="conveyance_monthly" className="label">
                                            Conveyance:
                                        </label>
                                    </div>
                                    <div className="col-span-2">
                                        <input
                                            onWheel={(e) => e.target.blur()}
                                            type="number"
                                            name="conveyance_monthly"
                                            value={salaryForm.conveyance_monthly}
                                            onBlur={calculateData}
                                            onChange={handleChangeCents}
                                            className="input"
                                            placeholder="0"
                                        />
                                    </div>
                                    <div className="col-span-2 text-center">
                                        <label
                                            htmlFor="conveyance_yearly"
                                            className="label bg-gray-100 input h-[2.6rem]"
                                        >
                                            {salaryForm?.conveyance_yearly}
                                        </label>
                                    </div>
                                </div>

                                <div className="grid grid-cols-8 mt-5 gap-x-8">
                                    <div className="col-span-2">
                                        <label htmlFor="other_allowance_monthly" className="label">
                                            Other Allowance:
                                        </label>
                                    </div>
                                    <div className="col-span-2">
                                        <input
                                            onWheel={(e) => e.target.blur()}
                                            type="number"
                                            name="other_allowance_monthly"
                                            value={salaryForm.other_allowance_monthly}
                                            onBlur={calculateData}
                                            onChange={handleChangeCents}
                                            className="input"
                                            placeholder="0"
                                        />
                                    </div>
                                    <div className="col-span-2 text-center">
                                        <label
                                            htmlFor="other_allowance_yearly"
                                            className="label bg-gray-100 input h-[2.6rem]"
                                        >
                                            {salaryForm?.other_allowance_yearly}
                                        </label>
                                    </div>
                                </div>

                                <div className="grid grid-cols-8 mt-5 gap-x-8">
                                    <div className="col-span-2">
                                        <label htmlFor="variable_fixed_monthly" className="label">
                                            Variable / Fixed:
                                        </label>
                                    </div>
                                    <div className="col-span-2">
                                        <input
                                            onWheel={(e) => e.target.blur()}
                                            type="number"
                                            name="variable_fixed_monthly"
                                            value={salaryForm.variable_fixed_monthly}
                                            onBlur={calculateData}
                                            onChange={handleChangeCents}
                                            className="input"
                                            placeholder="0"
                                        />
                                    </div>
                                    <div className="col-span-2 text-center">
                                        <label
                                            htmlFor="variable_fixed_yearly"
                                            className="label bg-gray-100 input h-[2.6rem]"
                                        >
                                            {salaryForm?.variable_fixed_yearly}
                                        </label>
                                    </div>
                                </div>
                                */}
                            </>
                        ) : (
                            // Old Scheme Fields
                            <>
                                {/* HRA */}
                                <div className="grid grid-cols-8 mt-5 gap-x-8">
                                    <div className="col-span-2">
                                        <label htmlFor="hra_monthly" className="label">
                                            HRA:
                                        </label>
                                    </div>
                                    <div className="col-span-2">
                                        <div className="flex items-center space-x-2">
                                            <input
                                                onWheel={(e) => e.target.blur()}
                                                type="number"
                                                name="hra_monthly"
                                                value={salaryForm.hra_monthly}
                                                onBlur={calculateData}
                                                onChange={handleChangeCents}
                                                className="input"
                                                placeholder="0"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-span-2 text-center">
                                        <label
                                            htmlFor="hra_yearly"
                                            className="label bg-gray-100 input h-[2.6rem]"
                                        >
                                            {salaryForm?.hra_yearly}
                                        </label>
                                    </div>
                                </div>

                                {/* Travel Allowance */}
                                <div className="grid grid-cols-8 mt-5 gap-x-8">
                                    <div className="col-span-2">
                                        <label htmlFor="travel_allowance_monthly" className="label">
                                            TA:
                                        </label>
                                    </div>
                                    <div className="col-span-2">
                                        <input
                                            onWheel={(e) => e.target.blur()}
                                            type="number"
                                            name="travel_allowance_monthly"
                                            value={salaryForm.travel_allowance_monthly}
                                            onBlur={calculateData}
                                            onChange={handleChangeCents}
                                            className="input"
                                            placeholder="0"
                                        />
                                    </div>
                                    <div className="col-span-2 text-center">
                                        <label
                                            htmlFor="travel_allowance_yearly"
                                            className="label bg-gray-100 input h-[2.6rem]"
                                        >
                                            {salaryForm?.travel_allowance_yearly}
                                        </label>
                                    </div>
                                </div>

                                {/* Washing Allowance */}
                                <div className="grid grid-cols-8 mt-5 gap-x-8">
                                    <div className="col-span-2">
                                        <label htmlFor="washing_allowance_monthly" className="label">
                                            WA:
                                        </label>
                                    </div>
                                    <div className="col-span-2">
                                        <input
                                            onWheel={(e) => e.target.blur()}
                                            type="number"
                                            name="washing_allowance_monthly"
                                            value={salaryForm.washing_allowance_monthly}
                                            onBlur={calculateData}
                                            onChange={handleChangeCents}
                                            className="input"
                                            placeholder="0"
                                        />
                                    </div>
                                    <div className="col-span-2 text-center">
                                        <label
                                            htmlFor="washing_allowance_yearly"
                                            className="label bg-gray-100 input h-[2.6rem]"
                                        >
                                            {salaryForm?.washing_allowance_yearly}
                                        </label>
                                    </div>
                                </div>

                                {/* Supplementary Allowance */}
                                <div className="grid grid-cols-8 mt-5 gap-x-8">
                                    <div className="col-span-2">
                                        <label htmlFor="supplementary_allowance_monthly" className="label">
                                            SA:
                                        </label>
                                    </div>
                                    <div className="col-span-2">
                                        <div className="flex items-center space-x-2">
                                            <input
                                                onWheel={(e) => e.target.blur()}
                                                type="number"
                                                name="supplementary_allowance_monthly"
                                                value={salaryForm.supplementary_allowance_monthly}
                                                onBlur={calculateData}
                                                onChange={handleChangeCents}
                                                className="input"
                                                placeholder="0"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-span-2 text-center">
                                        <label
                                            htmlFor="supplementary_allowance_yearly"
                                            className="label bg-gray-100 input h-[2.6rem]"
                                        >
                                            {salaryForm?.supplementary_allowance_yearly}
                                        </label>
                                    </div>
                                </div>

                                {/* Variable / Fixed */}
                                <div className="grid grid-cols-8 mt-5 gap-x-8">
                                    <div className="col-span-2">
                                        <label htmlFor="variable_fixed_monthly" className="label">
                                            Variable OT:
                                        </label>
                                    </div>
                                    <div className="col-span-2">
                                        <input
                                            onWheel={(e) => e.target.blur()}
                                            type="number"
                                            name="variable_fixed_monthly"
                                            value={salaryForm.variable_fixed_monthly}
                                            onBlur={calculateData}
                                            onChange={handleChangeCents}
                                            className="input"
                                            placeholder="0"
                                        />
                                    </div>
                                    <div className="col-span-2 text-center">
                                        <label
                                            htmlFor="variable_fixed_yearly"
                                            className="label bg-gray-100 input h-[2.6rem]"
                                        >
                                            {salaryForm?.variable_fixed_yearly}
                                        </label>
                                    </div>
                                </div>
                            </>
                        )}

                        {/* CTC Summary */}
                        <div className="grid grid-cols-8 mt-5 gap-x-8 bg-blue-100 rounded -mx-4 px-4 py-2">
                            <div className="col-span-2">
                                <label className="label text-2xl font-semibold">Cost to Company</label>
                            </div>
                            <div className="col-span-2">
                                <label className="label text-xl">&#8377; {salaryForm.monthly_ctc || 0}</label>
                            </div>
                            <div className="col-span-2 text-center">
                                <label className="label text-xl">&#8377; {salaryForm.annual_ctc || 0}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default CreateEmployeeSalary
